import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { changePasswordApi } from "../../end-points/changePassword";


const initialState = {
  loading: false,
  error: null,
  success: false,
};

export const changePassword = createAsyncThunk(
  "changePass/changePassword",
  async(payload, thunkAPI) => {
    try {
      const response = await changePasswordApi(payload);
      console.log("response", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const changePassSlice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(changePassword.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.loading = false;
      if(action.payload.messsage === "Password changed successfully."){
        state.success = true;
        state.error = null;
      }
      state.message = action.payload.message;
    })
    builder.addCase(changePassword.rejected, (state, action) => {
      console.log("Error", state, action);
      state.loading = false;
    })
  }
});

export default changePassSlice.reducer;